import { createFileRoute, redirect } from '@tanstack/react-router';

import { env } from '../../../env';

// /comms/rules — the triage/routing rules screen (Agent U4, spec 07 §6).
// Flag-gated: with VITE_COMM_CENTER OFF the route redirects away (no reachable
// Comm Center), so direct URL access is inert and the OFF build stays
// byte-identical. Nav never surfaces this route when OFF (Wave-2 nav wiring).
export const Route = createFileRoute('/_authenticated/comms/rules')({
  beforeLoad: () => {
    if (!env.VITE_COMM_CENTER) throw redirect({ to: '/inbox' });
  },
});
